class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    let timeout = 600

    const magicBackground = document.querySelector('magic-background')

    if(document.body.dataset.magicState == 'menu-opened') {
      document.body.dataset.magicState = 'modal-transition'
    } else {
      document.body.dataset.magicState = 'search-transition'
    }

    const searchContentWrapper = this.querySelector('.search-modal__content-wrapper')
    magicBackground.style.height = searchContentWrapper.offsetHeight + 'px'

    setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent)
      document.body.classList.add('scroll-disabled')
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }, timeout-100)

    setTimeout(()=> {
      document.body.dataset.magicState = 'search-opened'
    }, timeout)

  }

  close(focusToggle = true) {
    this.classList.add('closing')

    const magicBackground = document.querySelector('magic-background')
    magicBackground.style.height = 0
    document.body.dataset.magicState = ''

    document.body.classList.remove('scroll-disabled')

    setTimeout(() => {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      this.classList.remove('closing')
      this.querySelector('[data-scrollable]').scrollTop = 0
    }, 600)

  }
}

customElements.define('search-modal', SearchModal);
